import { Serializable } from "../core";

export class Category implements Serializable<Category> {
  public id!: string;
  public title!: string;

  deserialize(json: any): Category {
    this.id = json.id.toString();
    this.title = json.category;
    return this;
  }
}

export class SubCategory implements Serializable<SubCategory> {
  public id!: string;
  public title!: string;
  public categories!: Category[];

  deserialize(json: any, hasChildren = true): SubCategory {
    this.id = json.id.toString();
    this.title = json.sub_category;
    if (hasChildren)
      this.categories = json.category.map((json: any) =>
        new Category().deserialize(json)
      );
    return this;
  }
}

export class GeneralCategory implements Serializable<GeneralCategory> {
  public id!: string;
  public title!: string;
  public subCategories!: SubCategory[];

  deserialize(json: any, hasChildren = true): GeneralCategory {
    this.id = json.id.toString();
    this.title = json.general_category;
    if (hasChildren)
      this.subCategories = json.sub_category.map((json: any) =>
        new SubCategory().deserialize(json)
      );
    return this;
  }
}
